<template>
  <v-data-table
    sort-by="revision.date_created"
    :headers="headers"
    :items="items"
    :items-per-page="15"
    class="elevation-1"
  />
</template>

<script>
import { APIService } from "@/http/APIService.js";
const apiService = new APIService();

export default {

  data() {
    return {
      headers: [
        {
          text: "Dátum a čas",
          value: "revision.date_created"
        },
        { text: "Časť", value: "content_type.model" },
        { text: "Používateľ", value: "revision.user.username" },
        { text: "Poznámka", value: "revision.comment" }
      ],
      items: []
    };
  },
  created() {
    apiService.getUserHistory(this.$route.params.id).then(response => {
      this.items = response;
    });
  }
};
</script>